<!-- 登录框 -->
<template>
  <div class="popup_wrapper"
       :class="{'active': form_msg && form_msg.show}"
       @click="bind_hide_form">
    <div class="popup_form_wrapper"
         @click.stop>
      <div class="close"
           @click="bind_hide_form"><i class="el-icon-close"></i></div>
      <!-- 登录页头部 -->
      <div class="title_wrapper"
           v-show="type=='login'">
        <div class="title_en">LOGIN</div>
        <div class="title">登录</div>
      </div>
      <!-- 合作页头部 -->
      <div class="title_wrapper"
           v-show="type=='cooperation'">
        <div class="title_en">COOPERATION</div>
        <div class="title">申请合作</div>
      </div>
      <!-- 切换访客类型 -->
      <el-tabs @tab-click='bind_toggle_visitor_type'
               v-model='visitor_type'
               class="type_wrapper">
        <el-tab-pane label="广告主" name="advertiser"></el-tab-pane>
        <el-tab-pane label="开发者" name="developer"></el-tab-pane>
	  	<el-tab-pane v-if="type !== 'cooperation'" label="智选账号" name="zhixuanAccount"></el-tab-pane>
      </el-tabs>
      <!-- 登录页内容 -->
      <div class="login">
        <div id="urs-login-block"
			 v-show="type !== 'cooperation' && visitor_type !=='zhixuanAccount'"
             style='width: 420px;height: 213px;'
		>
		</div>

	  <div class="zhixuanAccount"
		   v-show="type !== 'cooperation' && visitor_type ==='zhixuanAccount'"
	  >
		  <el-form :model="zhixuanForm"
				   :rules="zhixuanRule"
				   ref="zhixuanForm"
				   style="display: flex; flex-direction: column; align-items: center;"
				   class="cooperation_form"
		  >
			  <el-form-item prop="username">
				  <el-input
					  v-model="zhixuanForm.username"
					  style="width: 320px; height: 46px;"
					  placeholder="智选账号（必填）"
				  >
					  <template slot="append">@zhixuan.163.com</template>
				  </el-input>
			  </el-form-item>
			  <el-form-item prop="password">
				  <el-input
					  show-password
					  v-model="zhixuanForm.password"
					  style="width: 320px; height: 46px; display: block;"
					  placeholder="密码（必填）"
				  ></el-input>
			  </el-form-item>
			  <div class="agreement_wrapper_zhixuan">
				  <el-checkbox v-model="zhixuanAgreeTerms" class="agreement_checkbox"></el-checkbox>
				  <span class="agreement_text">
					  我已阅读并同意<a href="https://zhixuan.163.com/zhixuanreg/protocol.html" target="_blank" class="agreement_link">服务协议</a>和<a href="https://c.youdao.com/dsp/law/privacy.html" target="_blank" class="agreement_link">隐私条款</a>
				  </span>
			  </div>
			  <el-button class="btnZhixuan" @click="zhixuan_submit_form" :disabled="!zhixuanAgreeTerms">登录</el-button>
		  </el-form>
	  </div>

        <div class="situation_wrapper"
			 v-show="type !== 'cooperation' && visitor_type !=='zhixuanAccount'"
		>
          <div class="forget"
               @click="bind_jump(forget_url)">忘记密码</div>
          <div class="register"
               @click="bind_jump(register_url)">免费注册</div>
        </div>
      </div>
      <!-- 合作页内容 -->
      <div class="cooperation"
           v-show="type=='cooperation'">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 class="cooperation_form">
          <el-form-item prop="name">
            <el-input v-model="ruleForm.name"
                      placeholder="姓名（必填）"></el-input>
          </el-form-item>
          <el-form-item prop="tel">
            <el-input v-model="ruleForm.tel"
                      placeholder="手机（必填）"></el-input>
          </el-form-item>
          <el-form-item class="qq"
                        prop="qq">
            <el-input v-model="ruleForm.qq"
                      placeholder="QQ"></el-input>
          </el-form-item>
          <el-form-item class="refer"
                        prop="refer">
            <el-input v-model="ruleForm.refer"
                      placeholder="推广网站/APP名称"></el-input>
          </el-form-item>
        </el-form>
        <div class="btn"
             @click="bind_submit_form">立即提交</div>
        <div class="jump_login">
          已有账号,<span @click="x('login')">立即登录</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CONSTANT from '@/util/constant';
export default {
  props: ['form_msg'],
  watch: {
    // 弹窗的类型
    // 默认是申请合作
    form_msg (curVal) {
      this.type = curVal.form_type;
	  this.visitor_type = 'advertiser';
      // 如果在流量变现页打开表单页，默认以开发者身份操作
      if (this.$route.path.indexOf('flow_to_cash') > -1) {
        this.visitor_type = 'developer';
      }
	  this.bind_toggle_visitor_type();
    }
  },
  data () {
    var validateTel = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else if (!(/^1[34578]\d{9}$/.test(value))) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    return {
      // 弹窗的类型
      type: '',
      // 访客类型（默认广告主）
      visitor_type: 'advertiser',
      // 忘记密码链接地址
      forget_url: 'http://reg.163.com/resetpwd/index.do',
      // 免费注册链接地址
      register_url: 'https://zhixuan.163.com/zhixuanreg/',
      // 表单数据
      ruleForm: {},
	  zhixuanForm: {},
	  // 智选账号登录的协议勾选状态
	  zhixuanAgreeTerms: false,
      // 表单规则
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        tel: [
          { validator: validateTel, trigger: 'blur' }
        ],
      },
		zhixuanRule: {
			username: [
				{ required: true, message: '请输入智选账号', trigger: 'blur' }
			],
			password: [
				{ required: true, message: '请输入密码', trigger: 'blur' }
			],
		}
    };
  },
  mounted () {
    // 初始化登录组件
    if (window.URS) {
      const self = this;
      this.urs = new window.URS({
        newCDN: 1,
        version: 4,
        // isHttps: 1,
        product: 'search',
        promark: 'wzZyaOh',
        host: '163.com',
        // mode: 'float',
        // productKey: '52963008b399524b1c86c7a4ba745aec',
        cookieDomain: '163.com',
        regCookieDomain: '163.com',
        prdomain: '@163.com',
        page: 'login',
        loginText: '登录',
        includeBox: 'urs-login-block',
        placeholder: { account: '网易邮箱' },
        single: 1,
        // 登录条款配置
        mailloginclause: {
          list: [
            { url: 'https://zhixuan.163.com/zhixuanreg/protocol.html', txt: '服务协议' },
            { url: 'https://c.youdao.com/dsp/law/privacy.html', txt: '隐私条款' }
          ],
          clauseErr: '请阅读并同意服务协议和隐私条款'
        },
        agreeText: '我已阅读并同意',
        andText: '和',
        // 邮箱登录初始化成功回调，必须调用setMailloginClause才能让条款功能生效
        loginInitSuccess: function () {
          // 0=取消勾选登录条款（默认不勾选，用户必须主动勾选才能登录）
          if (self.urs && self.urs.setMailloginClause) {
            self.urs.setMailloginClause(0);
          }
        },
        // notFastReg: 0,
        // needanimation: 0,
        //cssDomain: 'https://c.youdao.com/dsp/website/header/',
        //cssFile: 'URS.css',
        style: `
                        .u-logo{display:none}
                        .m-unlogin{display:none}
                        .m-footer{display:none}
                        .m-header{display:none}
                        .u-loginbtn{background: #FC754C !important;border-radius: 3px;font-size:16px;letter-spacing:10px;text-align:center}
                        .inputbox{background: #f7f9fc !important; border-radius: 4px;border-color:#f2f5fa !important;}
                        .j-inputtext{background: #f7f9fc;}
                        .pr-domain{background: #f7f9fc !important;}
                        .clause-link{color: #fc754c !important;}
                        .fur-agree a{color: #fc754c !important;}
                        .fur-agree a:hover{text-decoration: underline;}
                        .fur-agree {color: #666; font-size:12px; line-height: 20px;  font-family: PingFangSC, PingFangSC-Regular, Lantinghei SC, Helvetica Neue, Helvetica, Arial, Microsoft YaHei;}
                        `,
        logincb: function (username) {
          window.location.href = "https://zhixuan.163.com/login";
        }
      });
      this.urs.showIframe();
      this.urs.closeIframe();
    }
    if (document && !('placeholder' in document.createElement('input'))) {
      this.ruleForm = {
        name: '姓名（必填）',
        tel: '手机（必填）',
        qq: 'QQ',
        refer: '推广网站/APP名称'
      }
    }
  },
  methods: {
    // 切换类型
    x (tag) {
      this.type = tag;
    },
    bind_hide_form () {
      // 隐藏表单
      setTimeout(() => {
        this.form_msg.show = false;
      }, 100)
    },
    // 切换访客类型
    bind_toggle_visitor_type () {
      switch (this.visitor_type) {
        case 'advertiser':
          this.register_url = 'https://zhixuan.163.com/zhixuanreg/';
          this.urs.logincb = function () {
            window.location.href = "https://zhixuan.163.com/login";
          }
          break;
        case 'developer':
          this.register_url = 'https://zhixuan.163.com/devreg/';
          this.urs.logincb = function (username) {
            window.location.href = ` https://zhixuan.163.com/developer/login?fc=${username[0].toLowerCase()}`;
          }
          break;
        default:
          break;
      }
    },
    // 跳转
    bind_jump (url) {
      window.location.href = url;
    },
    // 提交表单信息
    bind_submit_form () {
      this.$refs.ruleForm.validate((valid) => {
        // 验证成功,提交表单
        if (valid) {
          let vals = [
            `name=${encodeURIComponent(this.ruleForm.name)}`,
            `phone=${encodeURIComponent(this.ruleForm.tel)}`,
            `qq=${encodeURIComponent(this.ruleForm.qq)}`,
            `reffer=${encodeURIComponent(this.ruleForm.refer)}`
          ]
          let turl = `${CONSTANT.FORM_URL}&${vals.join('&')}`;
          (new Image()).src = turl;
          this.bind_hide_form();
          setTimeout(() => {
            this.$message({
              message: '提交成功',
              center: true,
              type: 'success',
              customClass: 'msg_center',
              duration: 1000
            })
          }, 500)
        } else {
          return false
        }
      })
    },
	  zhixuan_submit_form () {
		  this.$refs.zhixuanForm.validate((valid) => {
			  // 验证成功,提交表单
			  if (!valid) return false
			  const userAccount = `${this.zhixuanForm.username}@zhixuan.163.com`

			  const params = new URLSearchParams();
			  params.append('username', userAccount);
			  params.append('password', this.zhixuanForm.password);

			  fetch('https://zhixuan.163.com/zhixuanLogin', {
				  	method: 'POST',
				    headers: {
					  'Content-Type': 'application/x-www-form-urlencoded',
					  Accept: 'application/json',
				    },
				    body: params
				  })
				  .then((res) => {
					  if (res.redirected && res.url) {
						  window.location.href = res.url; // 手动跳转
					  } else {
						  this.$message({
							  message: '账号或密码错误，请检查后重新输入',
							  center: true,
							  type: 'error',
							  customClass: 'msg_center',
							  duration: 1000
						  })
					  }
				  }).catch(e => {
					  this.$message({
						  message: '登录失败',
						  center: true,
						  type: 'error',
						  customClass: 'msg_center',
						  duration: 1000
					  })
			  })
		  })
	  },
  }
}
</script>
<style>
@keyframes show {
  0% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
/* 弹窗 */
.popup_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
  display: none;
}
.popup_wrapper.active {
  animation: 0.2s show linear;
  display: block;
}
/* 表单 */
.popup_form_wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  /* transform: translate(-50%, -50%); */
  margin-left: -210px;
  margin-top: -250px;
  width: 420px;
  height: 500px;
  padding: 44px 0;
  background: #fff;
  border-radius: 4px;
}
/* 关闭按钮 */
.popup_form_wrapper .close {
  cursor: pointer;
  position: absolute;
  font-size: 20px;
  right: 48px;
  top: 44px;
  z-index: 999;
}
/* 标题 */
.popup_form_wrapper .title_wrapper {
  padding: 0 48px;
  position: relative;
  margin-bottom: 20px;
}
.popup_form_wrapper .title_wrapper .title_en {
  text-align: left;
  font-size: 40px;
  line-height: 40px;
  font-weight: bold;
  color: #f3f4f7;
}
.popup_form_wrapper .title_wrapper .title {
  position: absolute;
  top: 20px;
  left: 48px;
  font-size: 32px;
  color: #18253d;
  line-height: 32px;
  font-weight: bold;
}
/* 类型（广告主/开发者） */
.type_wrapper {
  padding: 0 48px;
  margin-bottom: 17px;
}
.type_wrapper .el-tabs__item {
  color: #aaadb3;
}
.type_wrapper .el-tabs__item.is-active {
  color: #292c33;
}
.type_wrapper .el-tabs__active-bar {
  background-image: linear-gradient(-90deg, #fc833c 0%, #fc754c 98%);
  background-color: #FC754C; /* ie9 */
}
/* 忘记密码/注册 */
.situation_wrapper {
  margin-top: 10px;
  padding: 0 68px;
  font-size: 12px;
  color: #aaadb3;
  line-height: 12px;
}
.situation_wrapper .forget {
  float: left;
  cursor: pointer;
}
.situation_wrapper .register {
  float: right;
  cursor: pointer;
}
.situation_wrapper .forget:hover,
.situation_wrapper .register:hover {
  text-decoration: underline;
}
/*  申请合作 */
.cooperation {
  padding: 0 48px;
}
.cooperation_form {
  overflow: hidden;
}
.cooperation_form .qq {
  float: left;
  width: 132px;
}
.cooperation_form .refer {
  float: right;
  width: 180px;
}
.cooperation_form .el-input__inner {
  background: #f7f9fc;
  border: 1px solid #f2f5fa;
}
.cooperation .btn, .zhixuanAccount .btnZhixuan {
  padding: 0 48px;
  height: 44px;
  text-align: center;
  background-image: linear-gradient(-90deg, #fc833c 0%, #fc754c 98%);
  background-color: #FC754C; /* ie9 */
  font-size: 16px;
  line-height: 44px;
  letter-spacing: 10px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  font-family: PingFangSC, PingFangSC-Regular, Lantinghei SC, Helvetica Neue, Helvetica, Arial, Microsoft YaHei;
}
.btnZhixuan .el-button:focus, .elbutton:active {
  color: #fff;
}
.btnZhixuan{
	width: 320px;
}

.cooperation .jump_login {
  text-align: center;
  font-size: 12px;
  color: #aaadb3;
  line-height: 12px;
  margin-top: 16px;
}
.cooperation .jump_login span {
  padding: 0 5px;
  color: #000;
  cursor: pointer;
}
.el-input-group__append {
	border: none;
}
.zhixuanAccount .el-input input {
	display: inline-block;
	height: 46px;
}

.agreement_wrapper_zhixuan {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 320px;
	margin-bottom: 12px;
  margin-top: 4px;
}

.agreement_checkbox {
	flex-shrink: 0;
	margin-right: 4px;
}

.agreement_wrapper_zhixuan .el-checkbox__input.is-checked .el-checkbox__inner,
.agreement_wrapper_zhixuan .el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #fff;
	border-color: #000;
}

.agreement_wrapper_zhixuan .el-checkbox__input.is-checked .el-checkbox__inner::after {
	border-color: #67C23A;
}

.agreement_wrapper_zhixuan .el-checkbox__input.is-focus .el-checkbox__inner {
	border-color: #000;
}

.agreement_wrapper_zhixuan .el-checkbox__inner:hover {
	border-color: #67C23A;
}

.agreement_text {
	font-size: 12px;
	color: #666;
	line-height: 20px;
  margin-left: 6px;
}

.agreement_link {
	color: #fc754c;
	text-decoration: none;
	cursor: pointer;
}

.agreement_link:hover {
	text-decoration: underline;
}

.btnZhixuan:disabled {
	background: #ccc !important;
	cursor: not-allowed !important;
	opacity: 0.6;
}

.msg_center {
	z-index: 99999 !important;
}
.el-form-item {
  margin-bottom: 16px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/PopUp.vue